import { IntlProviderWithMessages, useLocale } from '@databases/intl';
import React, { Suspense } from 'react';

import { dynamicImport } from '@canvas/dynamic-import';

const DatabaseFatalError = React.lazy(() =>
  dynamicImport(() => import('@databases/frontend/DatabaseFatalError'))
);

export const ErrorApp = ({ error }: { error: Error }) => (
  <IntlProviderWithMessages locale={useLocale()}>
    <Suspense>
      <DatabaseFatalError error={error} />
    </Suspense>
  </IntlProviderWithMessages>
);
